import { Component } from '@angular/core';
import { NgSelectConfig } from '@ng-select/ng-select';
import { RouteTransitionDirectionService } from 'src/shared/transitions/route-transition-direction.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  constructor(
    private readonly ngSelectConfig: NgSelectConfig,
    private readonly routeTransitions: RouteTransitionDirectionService,
  ) {}
}
